import { environment } from '../../../environments/environment';
/**url / endpoint para la conexión al backend
* *Si environment.production es true devuelve url de "url_de_producción"
* *Si environment.production es false devuelve url de "url_de_desarrollo"
*
*/
const server_url:string = environment.production ? 'https://plataforma.chum.mx/CLIN-CHUM/':'http://localhost:8095/INV-CLIN-CHUM-1019-BACKEND/';

export default server_url;
